/**
 * What a promotion does to a list price.
 *
 * In `packages/shared` and not beside either caller, for the reason
 * `TEMPLATE_MEDIA_LIMITS` is: the CRM editor previews the resulting price while
 * the admin types, and the backend charges it. Two implementations of this
 * arithmetic is a preview that disagrees with the invoice by a centavo on half a
 * catalog — and the preview is the screen where someone decides the number is
 * right.
 *
 * Everything is integer minor units. `Math.round` is half-up, which is what a
 * Mexican price list does.
 */
export function promotionPriceCents(baseCents, p) {
    if (p.kind === "price_override") {
        // Returned as given, INCLUDING above the list price: peak-hour pricing is
        // the case this capability exists for. A row missing its amount leaves the
        // price alone rather than charging zero.
        return p.overridePriceCents ?? baseCents;
    }
    const bp = p.percentOffBp;
    if (bp === null)
        return baseCents;
    // The DISCOUNT is rounded, not the resulting price, so `base - effective` is
    // exactly the discount anyone computes by hand and a rounding that lands on
    // zero leaves the price untouched.
    const discount = Math.round((baseCents * bp) / 10_000);
    // Clamped: a 100 % promotion on a 1-centavo product must not go negative.
    return Math.max(0, baseCents - discount);
}
//# sourceMappingURL=promotion-price.js.map